module.exports = __webpack_public_path__ + "nunito-sans-latin-200italic.6efd102c0b004908b9454b4e4610d693.woff2";